import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import './index.css';
import { useDocTitle } from './components/CustomHook';
import AOS from 'aos';
import 'aos/dist/aos.css';
import backgroundImage from './images/green-fields.jpg';

function App() {

  useEffect(() => {
    // Set the background image as a CSS custom property
    document.documentElement.style.setProperty('--background-image', `url(${backgroundImage})`);
    
    const aos_init = () => {
      AOS.init({
        once: true,
        duration: 1000,
        easing: 'ease-out-cubic',
      });
    }

    window.addEventListener('load', () => {
      aos_init();
    });
  }, []);

  useDocTitle("Normandy Farm");

  return (
    <>
      <Router>
        <Routes>
          <Route path="/" element={<Home />} />
        </Routes>
      </Router>
    </>
  );
}

export default App;
